var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66667 2.66666C5.03486 2.66666 5.33333 2.96514 5.33333 3.33333L5.33333 12.6667C5.33333 13.0349 5.03486 13.3333 4.66667 13.3333C4.29848 13.3333 4 13.0349 4 12.6667L4 3.33333C4 2.96514 4.29848 2.66666 4.66667 2.66666Z",
    fill: "currentFill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.13807 5.80474C6.87772 6.06509 6.45561 6.06509 6.19526 5.80474L4.66666 4.27614L3.13807 5.80474C2.87772 6.06509 2.45561 6.06509 2.19526 5.80474C1.93491 5.54439 1.93491 5.12228 2.19526 4.86193L4.19526 2.86193C4.32028 2.73691 4.48986 2.66666 4.66667 2.66666C4.84348 2.66666 5.01304 2.73691 5.13807 2.86193L7.13807 4.86193C7.39842 5.12228 7.39842 5.54439 7.13807 5.80474Z",
    fill: "currentFill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 13.3333C11.0349 13.3333 11.3333 13.0349 11.3333 12.6667V3.33333C11.3333 2.96514 11.0349 2.66666 10.6667 2.66666C10.2985 2.66666 10 2.96514 10 3.33333V12.6667C10 13.0349 10.2985 13.3333 10.6667 13.3333Z",
    fill: "currentFill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1381 10.1953C12.8777 9.9349 12.4556 9.9349 12.1953 10.1953L10.6667 11.7238L9.13807 10.1953C8.87772 9.9349 8.45561 9.9349 8.19526 10.1953C7.93491 10.4556 7.93491 10.8777 8.19526 11.1381L10.1953 13.1381C10.3203 13.2631 10.4899 13.3333 10.6667 13.3333C10.8435 13.3333 11.013 13.2631 11.1381 13.1381L13.1381 11.1381C13.3984 10.8777 13.3984 10.4556 13.1381 10.1953Z",
    fill: "currentFill"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.422ced5e.svg";
export { ForwardRef as ReactComponent };